<div class="payment-cards-container">

    <!-- card info -->
    <mat-card dir="rtl">
        <!-- loading progressbar -->
        <mat-progress-bar mode="indeterminate" color="primary" *ngIf="isWaiting || isSubmitting">
        </mat-progress-bar>

        <mat-card-content [style.opacity]="(isWaiting || isSubmitting) ? .6 : 1">

            <!-- user avatar and fullname -->
            <div class="text-center">
                <div class="user-avatar">
                    <img [src]="cardInfo?.avatar ? cardInfo?.avatar : 'assets/img/user-avatar-placeholder.png'"
                        width="72" height="72" alt="آواتار کاربر">
                </div>
            </div>

            <!-- card number and amount remainder -->
            <ul class="list-group">
                <li class="list-group-item">
                    <div>نام صاحب کارت</div>
                    <div dir="ltr">
                        <b>
                            {{cardInfo?.fullname}}
                        </b>
                    </div>
                </li>

                <li class="list-group-item">
                    <div>شماره کارت</div>
                    <div dir="ltr">
                        <b>{{cardInfo?.cardno | creditCard}}</b>
                    </div>
                </li>
                <li class="list-group-item">
                    <div>حداکثر مبلغ قابل شارژ</div>
                    <div>
                        <b>
                            {{cardInfo?.remain
                                ? ((cardInfo?.remain | number) + ' ' + 'ریال')
                                : 'محدودیت ندارد'}}
                        </b>
                    </div>
                </li>
            </ul>

        </mat-card-content>

    </mat-card>



    <!-- charge amount card -->
    <mat-card dir="rtl">
        <mat-card-header [style.opacity]="isSubmitting ? .6 : 1">
            <mat-card-title>مبلغ شارژ</mat-card-title>
            <mat-card-subtitle>
                لطفا مبلغ مورد نظر خود را انتخاب و یا وارد کنید
            </mat-card-subtitle>
        </mat-card-header>

        <!-- payment form -->
        <mat-card-content [style.opacity]="isSubmitting ? .6 : 1">
            <app-payment-form [cardInfo]="cardInfo" (submitted)="onFormSubmit($event)">
            </app-payment-form>
        </mat-card-content>


        <!-- psp logos -->
        <mat-card-actions [style.opacity]="isSubmitting ? .6 : 1">
            <div class="psp-logo-container">
                <div class="psp-logo-saman"></div>
                <div class="psp-logo-asanpardakht"></div>
                <div class="psp-logo-parsian"></div>
            </div>
        </mat-card-actions>
    </mat-card>

</div>